import { Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { RowControlsRenderer } from "../../shared/components/AgGrid/RowControlsRenderer";
import { getDateFormatter, gridConfig } from "../../shared/constants/AgGrid/GridConfig";
import RequestSubTypeDocDetails from "./RequestSubTypeDocDetails/RequestSubTypeDocDetails";
import './RequestSubTypeDoc.css';
import { getDateColumnConfig } from "../../shared/services/SharedService";
import RefreshIcon from '@material-ui/icons/Refresh';

export default function RequestSubTypeDoc(props) {
  const [requestTypeDocList, setRequestTypeDocList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [activeRequestList, setActiveRequestList] = useState([]);

  useEffect(() => {
    getActiveRequestSubList(true);
    getRequestSubTypeDocList(true);
  }, []);

  const getRequestSubTypeDocList = async (resetPage) => {
    try {
      let data;

      const response = await axios.get(
        `${global.REACT_APP_API_ENDPOINT}/documentRanking/getAllDocumentRanking`, 
        {}
      );
      data = response.data;

      setRequestTypeDocList(data);
      props.setGridData(data);
    } catch (err) {
      console.log(err);
    }
  };

  const getActiveRequestSubList = async (resetPage) => {
    try {
      const response = await axios.get(
        `${global.REACT_APP_API_ENDPOINT}/requestType/getRequestSubTypes`, 
        {}
      );
      let data = response.data;
      setActiveRequestList(data?.length > 0 ? data.filter(d => d.active) : data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddClick = () => {
    setSelectedData({});
    setEdit(false);
    setShowModal(true);
  };

  const handleEditClick = (data) => {
    setSelectedData(data);
    setEdit(true);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setSelectedData({});
    setEdit(false);
    setShowModal(false);
  };

  const handleSave = () => {
    handleModalClose();
    getRequestSubTypeDocList(false);
  };

  const validationOnSave = (data, errorData) => {
    let isValid = true;
    [{ key: 'documentName', label: 'Document Name', errorKey: 'documentNameErr' }, 
     { key: 'rank', label: 'Document Rank', errorKey: 'rankErr' }].forEach(attr => {
      const duplicates = requestTypeDocList.filter(ele => ele[attr.key] == data[attr.key]);
      
      if (duplicates.length === 0) {
        return;
      }
      if (isEdit && data.documentRankingId == duplicates[0].documentRankingId) {
        return;
      }
      errorData[attr.errorKey] = `${attr.label} already exists`;
      isValid = false;
    });
    return isValid;
  };

  const gridRef = useRef(null);
  
  const gridOptions = {
    ...gridConfig,

    columnDefs: [
      { headerName: "Document Name", field: "documentName", sort: "asc", },
      { headerName: "Ranking", field: "rank" },
      { headerName: "Created By", field: "createdBy", },
      { headerName: "Updated By", field: "updatedBy", },
      {
        headerName: "Updated At",
        field: "updatedDate",
        ...getDateColumnConfig(),
      },
      { 
        headerName: "", 
        sortable: false,
        filter: false,
        cellRenderer: RowControlsRenderer, 
        cellRendererParams: {
          canEdit: true,
          onEditClick: handleEditClick,
        },
        maxWidth: 90,
      },
    ],

    dataTypeDefinitions: {
      ...gridConfig.dataTypeDefinitions,
      date: getDateFormatter("MM/DD/YYYY hh:mm:ss A"),
    },
  };
  
  useEffect(() => {
    props.setGridOptions(gridOptions);
  }, []);

  const onRefreshClick = () => {
    getActiveRequestSubList(true);
    getRequestSubTypeDocList(true);
    props.gridRef.current.api.resetColumnState();
    props.gridRef.current.api.paginationGoToPage(0);
  }

  return (
    <>
    {
      props.gridRef?props.gridRef.current?props.gridRef.current.api?
      props.gridRef.current.api.paginationGoToPage(0):null:null:null  
    }
      <div style={{ position: "absolute", top: "-50px", right: 0 }}>
        <Button
          variant="contained"
          onClick={handleAddClick}
          style={{
            backgroundColor: "rgb(17, 118, 181)",
            textTransform: "none"
          }}
          color="primary"
        >
          <Add />
          Add Document
        </Button>
      </div>


      <div style={{position: "absolute", top: "-50px", right: 200}}>
        <Button
          variant="contained"
          onClick={onRefreshClick}
          style={{
            backgroundColor: "rgb(17, 118, 181)",
            textTransform: "none"
          }}
          color="primary"
        >
          Refresh
          <RefreshIcon />
        </Button>
      </div>

      {requestTypeDocList?.length ? (     
        <></>
      ) : (<p className="error"> No records found. </p>)}

      <RequestSubTypeDocDetails
        show={showModal}
        isEdit={isEdit}
        handleClose={handleModalClose}
        handleSave={handleSave}
        data={selectedData}
        handleValidation={validationOnSave}
        activeRequestList={activeRequestList}
        documentRankings={requestTypeDocList} 
      />
    </>
  );
}
